export const DB_USER = "capstone_team";
export const DB_HOST = "178.16.140.57";
export const DB_NAME = "icarevillage_db_backup";
export const DB_PASSWORD = 2024;
export const DB_PORT = 5432;
export const ENDP_PORT = 3000;
// export const API_IP = "http://localhost:3004";
export const GOOGLE_API_KEY = "AIzaSyABT3QIyPBqvUeDu9ZXIPXrWXdK1z7rW10";
export const STRIPE_KEY =
  "pk_test_51NLbbpHoG5eJHlgiMMqOMMhGPlk8w2UsxGBzvyOBF0X1LlwBjHjRaZuazz7reLylPn4YPXqMNqpt5x3m5gIYL64P007s91KWfn";
export const AMITY_KEY = "b0e8e1533fd3f1314e65d81d5b01138d835a85b3e9606d7a";
export const API_IP = "https://icaresolutions.ca:3004";
// export const API_IP = "http://192.168.1.63:3004";
